module.exports = __webpack_public_path__ + "img/footer-logo.9d335840.svg";